import { render, staticRenderFns } from "./AdminGrid.vue?vue&type=template&id=20701180&scoped=true&"
import script from "./AdminGrid.vue?vue&type=script&lang=ts&"
export * from "./AdminGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AdminGrid.vue?vue&type=style&index=0&id=20701180&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20701180",
  null
  
)

export default component.exports